import keyMirror from 'keymirror';

const passengerTypes = keyMirror({
  ADULT: null,
  CHILD: null,
  INFANT: null,
});

export default passengerTypes;
